import { GET } from "@/lib/methods";
import type { FoodangoUser } from "@/types/foodango-user";

export const getUser = async () =>
  GET<FoodangoUser>({
    url: `${process.env.NEXT_PUBLIC_FOOAPP_URL}/user`,
    params: {
      cache: "default",
      headers: {
        "Content-Type": "application/json",
      },
    },
  }).catch(() => null);
